import React from 'react';
import { Section } from './ui/Section';
import { ArrowDown, Check } from 'lucide-react';
import { motion } from 'framer-motion';
export default function ResultSection() {
  const steps = ['llega la tarde,', 'ya no hay debate,', 'ya sabes qué toca,', 'ya está comprado,', 'y si el día se cae… tienes Plan B.'];
  return <Section className="bg-brand-cream relative overflow-hidden" data-id="element-355">
      <div className="absolute inset-0 bg-gradient-to-t from-brand-brown/5 to-transparent pointer-events-none" data-id="element-356" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-357">
        <h2 className="font-heading text-4xl md:text-5xl text-slate-900 mb-12 uppercase tracking-wide" data-id="element-358">
          Tu primer resultado real se siente así:
        </h2>

        <div className="space-y-6 mb-16" data-id="element-359">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.15
        }} className="flex flex-col items-center" data-id="element-360">
              <div className="flex items-center gap-3" data-id="element-361">
                <motion.div initial={{
              scale: 0
            }} whileInView={{
              scale: 1
            }} transition={{
              delay: index * 0.15 + 0.2,
              type: 'spring'
            }} className="bg-brand-purple/15 p-1 rounded-full" data-id="element-362">
                  <Check size={16} className="text-brand-purple" data-id="element-363" />
                </motion.div>
                <p className={`text-2xl md:text-3xl font-light ${index >= 3 ? 'text-slate-800' : 'text-slate-500'}`} data-id="element-364">
                  {step}
                </p>
              </div>
              {index < steps.length - 1 && <ArrowDown className="text-brand-brown/40 my-2" size={24} data-id="element-365" />}
            </motion.div>)}
        </div>

        <motion.div whileHover={{
        scale: 1.02
      }} className="bg-white p-8 rounded-2xl border border-brand-brown/20 shadow-lg hover:shadow-xl transition-all duration-500" data-id="element-366">
          <p className="text-2xl md:text-3xl text-slate-800 font-heading mb-4 uppercase tracking-wide" data-id="element-367">
            La emoción que aparece no es euforia.{' '}
            <span className="text-brand-brown font-bold" data-id="element-368">Es alivio.</span>
          </p>
          <p className="text-xl text-slate-500" data-id="element-369">
            Ese «orgullo silencioso» de:{' '}
            <span className="text-slate-800 font-bold" data-id="element-370">
              «Esta vez sí se sostuvo.»
            </span>
          </p>
        </motion.div>
      </div>
    </Section>;
}